import { ApiCallError } from 'app/http/ApiCallError';

export type BillingResourceError = { kind: 'none' } | { kind: 'forbidden' } | { kind: 'retryable' };

export const getBillingResourceError = (error: unknown): BillingResourceError => {
  if (error instanceof ApiCallError) {
    if (error.status === 401) {
      return { kind: 'none' };
    }
    if (error.status === 403) {
      return { kind: 'forbidden' };
    }
  }

  return { kind: 'retryable' };
};
